import { useParams } from "react-router-dom";
import SportsSetTemplatePage from "./SportsSetTemplatePage";

export default function SportsSetRoutePage({ sport }) {
  const params = useParams();
  return (
    <SportsSetTemplatePage
      sport={sport || params.sport}
      setSlug={params.setSlug}
    />
  );
}
